import { render, staticRenderFns } from "./WidgetPanel.vue?vue&type=template&id=f995f8a2&scoped=true&"
import script from "./WidgetPanel.vue?vue&type=script&lang=js&"
export * from "./WidgetPanel.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPanel.vue?vue&type=style&index=0&id=f995f8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f995f8a2",
  null
  
)

export default component.exports